import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { OperatorAdminService } from '../../services/operator-admin/operator-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { PermissionService } from '../../services/permission/permission.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { OaUtsavFormDialogComponent } from './oa-utsav-form-dialog/oa-utsav-form-dialog.component';
import { OaUtsavReportsDialogComponent } from './oa-utsav-reports-dialog/oa-utsav-reports-dialog.component';

@Component({
  selector: 'app-oa-utsav',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './oa-utsav.component.html',
  styleUrl: './oa-utsav.component.scss',
})
export class OaUtsavComponent implements OnInit {
  utsavs: any[] = [];
  isLoading: boolean = false;
  canManage: boolean = false;
  canActivate: boolean = false;

  constructor(
    private operatorAdminService: OperatorAdminService,
    private toastService: ToastService,
    private permissionService: PermissionService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.canManage = this.permissionService.can('utsav-management', 'can_manage');
    this.canActivate = this.permissionService.can('utsav-management', 'can_activate');
    this.load();
  }

  get hasActions(): boolean {
    return this.canManage || this.canActivate;
  }

  load(): void {
    this.isLoading = true;
    this.operatorAdminService.listUtsav().subscribe({
      next: (res: any) => {
        this.utsavs = res?.data?.utsavList || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.utsavs = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load utsavs.');
      },
    });
  }

  openReports(utsav: any): void {
    this.dialog.open(OaUtsavReportsDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      data: { utsavInstanceId: utsav.utsavInstanceId, title: utsav.title },
    });
  }

  openForm(utsav: any | null): void {
    const ref = this.dialog.open(OaUtsavFormDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      data: { utsav },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }

  activate(u: any): void {
    this.isLoading = true;
    this.operatorAdminService.activateUtsav(u.utsavInstanceId).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Utsav activated.');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to activate utsav.');
      },
    });
  }
}
